import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BreadcrumbsService } from '../../core/breadcrumbs.service';
import { ScrollService } from '../../core/scroll.service';
import { LangService } from '../../core/lang.service';
import { Subscription } from 'rxjs';
import { ChecklistStep, ChecklistStepRoute } from '../pnel-cts-checklist/model/checklist-steps';
import * as moment from 'moment';
import { IAccountType } from '../../constants/account-types';
import { LoginGuardService } from '../../api/login-guard.service';
import { AuthService } from '../../api/auth.service';
import { RoutesService } from '../../api/routes.service';
import { MyTestSessionsSetupService } from '../my-test-sessions-setup.service';

interface ITechFormPatchReq {
  setupId?: number,
  filePath: string,
  deliveryFormat: string,
}

enum DeliveryOption { 
  COMPUTER_LAB = 'computer-lab',
  BYOD = 'byod',
}


@Component({
  selector: 'view-cts-techready',
  templateUrl: './view-cts-techready.component.html',
  styleUrls: ['./view-cts-techready.component.scss']
})
export class ViewCtsTechreadyComponent implements OnInit {
  public breadcrumb = [];
  public setupId:string;

  private routeSub:Subscription;
  public currentSelect:DeliveryOption

  constructor(
    private loginGuard: LoginGuardService, // 
    private breadcrumbsService: BreadcrumbsService,
    private router:Router,
    private route:ActivatedRoute,
    private scrollService:ScrollService,
    private lang:LangService,
    private routes: RoutesService,
    public auth:AuthService,
    private mySetup:MyTestSessionsSetupService,
  ) { }
  
  ngOnInit() {
    this.loginGuard.activate([IAccountType.TEST_ADMIN]);
    this.scrollService.scrollToTop();
    this.routeSub = this.route.params.subscribe(routeParams => {
      this.setupId = routeParams['setupId'];
      this.breadcrumb = this.mySetup.generateBreadcrumbs(this.setupId, 'cts_techre_title');
      this.initRouteView();
    });
  }

  isInited:boolean;
  initRouteView(){
    this.mySetup.sub().subscribe(setupInfo =>{
      if (!this.isInited && setupInfo){
        this.isInited = true;
        if (setupInfo.deliveryFormat){
          this.currentSelect = <DeliveryOption>setupInfo.deliveryFormat;
        }
      }
    })
  }

  notAvailable(e){
    // if (e){ e.preventDefault(); }
    alert( this.lang.tra('alert_form_unavail'))
  }

  getCurrentStepId(){
    return ChecklistStep.TechnicalReadiness
  }
  
  startUpload(event: FileList) {
    // console.log('startUpload')
    const file = event.item(0);
    this.auth
      .uploadFile(file, 'cts-tech-readi')
      .then(uploadRes => {
        const filePath = uploadRes.filePath;
        return this.deliverPayloadUpdate(this.currentSelect, filePath);
      })
      .then (res => {
        this.mySetup.refresh();
      })
  }
  
  deliverPayloadUpdate(deliveryFormat:string, filePath?:string){
    const setupId = parseInt(this.setupId);
    const req: ITechFormPatchReq = { 
      setupId, 
      deliveryFormat,
      filePath,
    };
    return this.auth.apiPatch(this.routes.TEST_ADMIN_TEST_SESSION_SETUP_TECH_READY, null, req);
  }

  isComputerLab(){
    return (this.currentSelect === DeliveryOption.COMPUTER_LAB);
  }
  isByod(){
    return (this.currentSelect === DeliveryOption.BYOD);
  }
  selectComputerLab(){
    if (this.currentSelect !== DeliveryOption.COMPUTER_LAB){
      this.deliverPayloadUpdate(DeliveryOption.COMPUTER_LAB).then(()=>{
        this.currentSelect = DeliveryOption.COMPUTER_LAB;
      });
    }
  }
  selectByod(){
    if (this.currentSelect !== DeliveryOption.BYOD){
      this.deliverPayloadUpdate(DeliveryOption.BYOD).then(()=>{
        this.currentSelect = DeliveryOption.BYOD;
      });
    }
  }
  isFormAvailable(){
    return this.isByod() || this.isComputerLab();
  }

  isReadyToContinue(){
    return this.mySetup.getChecklistStepState(ChecklistStepRoute.TechnicalReadiness)
  }

  gotoNextRoute(){
    const nextRouteSuffix = ChecklistStepRoute.DateAndTime;
    let breadcrumb = this.breadcrumbsService.TESTADMIN_CREATE_TEST_SESSION(this.setupId, nextRouteSuffix);
    this.router.navigate([ breadcrumb.route ]);
  }

}
